module.exports = __webpack_public_path__ + "img/20.31f65a9d.jpg";